//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FactorGroupDrawer from "./modules/FactorGroupDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
export default {
  name: 'FactorGroupList',
  mixins: [JeecgListMixin],
  components: {
    FactorGroupDrawer: FactorGroupDrawer
  },
  data: function data() {
    return {
      pagePath: '/site/factor/group',
      pageTitle: '环境监测因子组',
      // 表头
      columns: [// {
      //   title: '序号',
      //   dataIndex: '',
      //   key: 'rowIndex',
      //   width: 60,
      //   align: 'center',
      //   customRender: function(t, r, index) {
      //     return parseInt(index) + 1
      //   }
      // },
      {
        dataIndex: 'code',
        colName: 'code',
        title: '编号',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'title',
        colName: 'title',
        title: '名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'status',
        colName: 'status',
        title: '状态',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'sort',
        colName: 'sort',
        title: '排序号',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {}
};